import type { SxProps, Theme } from '@mui/material';
import { Box } from '@mui/material';
import type { PropsWithChildren } from 'react';
import React from 'react';
import { FullPageWidthWrapper } from '../../../../component_library/components/Grid';
import { useHomepageModuleWrapper } from './hooks';

interface IProps {
  dataComponentName: string;
  sx?: SxProps<Theme>;
}

// Common wrapper for modules with the same content paddings.
const HomepageModuleWrapper: React.FC<PropsWithChildren<IProps>> = ({
  dataComponentName = '',
  sx = {},
  children,
}) => {
  const { muiTheme } = useHomepageModuleWrapper();

  const rootStyle: SxProps<Theme> = {
    paddingTop: '88px',
    paddingBottom: '88px',
    [muiTheme.breakpoints.down('tablet')]: {
      paddingTop: '64px',
      paddingBottom: '64px',
    },
    ...sx,
  };

  return (
    <FullPageWidthWrapper
      id={dataComponentName}
      data-component={dataComponentName}
      sx={rootStyle}
    >
      {children}
    </FullPageWidthWrapper>
  );
};

// This component is used when we need to emulate
// that 2 HomepageModuleWrapper elements look like one module and without extra wrappings.
export const EmptyModuleWrapperWithoutExtraPadding: React.FC = () => {
  const { muiTheme } = useHomepageModuleWrapper();

  const rootStyle = {
    [muiTheme.breakpoints.down('desktop')]: {
      marginTop: '-88px',
    },
    [muiTheme.breakpoints.down('tablet')]: {
      marginTop: '-64px',
    },
  };

  return <Box sx={rootStyle} />;
};

export default HomepageModuleWrapper;
